import Page from 'components/Page';
import React from 'react';
import {Button, ButtonGroup, Card, CardBody, Col, FormGroup, Input, Label, Row, Table,} from 'reactstrap';
import BasePage from './BasePage';
import {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {isEmpty, navigatePage, parseDate} from '../utils/Utilities';
import {MdDelete, MdEdit} from 'react-icons/md';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import ActiveOption from '../components/Widget/ActiveOption';
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import ActiveLabel from '../components/Widget/ActiveLabel';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import DropdownInput from "../components/form/DropdownInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import NumberInput from "../components/Widget/NumberInput";
import ValidatorLabel from "../components/Widget/ValidatorLabel";
import SearchInput from "../components/SearchInput";


const tableTypes = ['', 'bordered', 'striped', 'hover'];


class MasterComponentPage extends BasePage{
  constructor(props) {
    super(props);
    this.state = {
      masterComponents : [],
      masterComponent:{
        active:true,
        length:255
      },
      labelError:undefined,
      descriptionError : undefined,
      lengthError : undefined,
      search:"",
      modalAddConfirm:false,
      modal: false,
      ascending:false,
      sortir:'mc.created',
      page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
      totalPage:0,
      totalElement:0,
      pageElement:0,
    }
  }

  componentWillReceiveProps(props, nextContext) {
    if(props!=this.props){
      this.setState({
        page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
      }, () => {
        this.fetchAll()
      })
    }
  }


  componentDidMount() {
    super.componentDidMount();
    this.fetchAll()
  }

  confirmSave = () =>{
    let { masterComponent, labelError, descriptionError, lengthError} = this.state
    let valid = true ;
    if(isEmpty(masterComponent.label)){
      valid = false ;
      labelError = label.PleaseEnterALabel
    }
    if(isEmpty(masterComponent.description)){
      valid = false ;
      descriptionError = label.PleaseEnterADescription
    }
    if(isEmpty(masterComponent.length)){
      valid = false ;
      lengthError = label.PleaseEnterACharacterLength
    }
    if(valid){
      this.setState({
        modalAddConfirm:true
      })
    }else{
      this.setState({labelError, descriptionError, lengthError})
    }
  }

  save = () => {
    let masterComponent = this.state.masterComponent
    if(!masterComponent.id && !masterComponent.active){
      masterComponent.active = false ;
    }

    this.setState({
      modalAddConfirm:false
    }, () => {
      this.post(Endpoint.API.MASTER_COMPONENT_SAVE, masterComponent, null, res => {
        if(res.code===200){
          this.showInfoToast(label.SuccessUpdatingData)
          this.setState({
            masterComponent:{}
          }, () => {
            this.fetchAll()
          })
        }
      }, true, true);
    })
  }

  confirmDelete = () =>{
    this.setState({
      modalDeleteConfirm:true
    })
  }

  closeDialog = () =>{
    this.setState({
      modalAddConfirm:false,
      modalDeleteConfirm:false
    })
  }

  fetchAll = () => {
    let {ascending, sortir, page, search} = this.state
    this.get(Endpoint.API.MASTER_COMPONENTS, {
      params:{
        search:search,
        ascending:ascending,
        sortir:sortir,
        page:page-1
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          masterComponents : response.data,
          totalPage: response.totalPage,
          totalElement: response.totalElement,
          pageElement: response.pageElement,
        })
      }
    }, true, true);
  }

  refresh = (ascending, sortir) => (
      this.setState({
        ascending:ascending,
        sortir:sortir
      }, () => {
        this.fetchAll()
      })
  )


  render() {
    let {ascending, sortir, search, masterComponents, masterComponent, labelError, descriptionError, lengthError, page, totalPage} = this.state
    if(!masterComponents){
      masterComponents = []
    }
    if(!masterComponent){
      masterComponent = {}
    }
    if(!masterComponent.id){
      masterComponent.active = true
      masterComponent.length = 255
    }
    let orderOptions = delegateObjectsForSelection(
        {name:label.Name, field:'mc.label'},
        {name:label.Created, field:'mc.created'},
        {name:label.Updated, field:'mc.updated'}
    )
    let ascendingOptions = delegateObjectsForSelection(  {name:label.Descending, field:false}, {name:label.Ascending, field:true})
    return (
        <Page
            title={label.MasterComponent}
            breadcrumbs={[{ name: label.MasterComponent, active: true }]}
            className="TablePage">
          {super.render()}
          <ConfirmDialog
              showing={this.state.modalAddConfirm}
              title={label.UpdateConfirmation}
              message={label.UpdateConfirmationMessage}
              okCallback={this.save}
              cancelCallback={this.closeDialog}/>
          <Row key={1}>
            <Col>
              <Card>
                <PrimaryCardHeader content={label.ComponentList}/>
                <CardBody >
                  <Row>
                    <Col md={3}>
                      <Card>
                        <PrimaryCardHeader content={label.FormInformation}/>
                        <CardBody>
                          <Row>
                            <Col>
                              <FormGroup>
                                <Label for="name">{label.Name}</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={!isEmpty(masterComponent.label)?masterComponent.label:""}
                                    onChange={(e) =>{
                                      masterComponent.label = e.target.value
                                      this.setState({
                                        masterComponent, labelError:undefined
                                      })
                                    }}
                                    placeholder={label.EnterComponentName}
                                />
                                <ValidatorLabel message={labelError}/>
                              </FormGroup>
                              <FormGroup>
                                <Label for="name">{label.Description}</Label>
                                <Input
                                    type="textarea"
                                    rows={4}
                                    name="description"
                                    value={!isEmpty(masterComponent.description)?masterComponent.description:""}
                                    onChange={(e) =>{
                                      masterComponent.description = e.target.value
                                      this.setState({
                                        masterComponent, descriptionError:undefined
                                      })
                                    }}
                                    placeholder={label.EnterComponentDescription}
                                />
                                <ValidatorLabel message={descriptionError}/>
                              </FormGroup>
                              <FormGroup>
                                <Label for="length">{label.CharacterLengthDefault(255)}</Label>
                                <NumberInput
                                    name="length"
                                    className="form-control"
                                    value={masterComponent.length}
                                    onChangeEvent={(e, maskedvalue, floatvalue) => {
                                      e.preventDefault()
                                      masterComponent.length = floatvalue
                                      this.setState({
                                        masterComponent, lengthError:undefined
                                      })
                                    }}
                                    placeholder="255"
                                    maxLength={3}>
                                </NumberInput>
                                <ValidatorLabel message={lengthError}/>
                              </FormGroup>
                              <FormGroup>
                                <ActiveOption
                                    default={masterComponent.active}
                                    callback={(active)=>{
                                      masterComponent.active = active
                                      this.setState({
                                        masterComponent
                                      })
                                    }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonGroup className="float-left">
                                <Button color="danger" onClick={e => (
                                    this.setState({
                                      masterComponent:null
                                    })
                                )}>{label.Cancel}</Button>
                              </ButtonGroup>
                            </Col>
                            <Col>
                              <ButtonGroup className="float-right">
                                <Button color="primary" onClick={e=>(
                                    this.confirmSave()
                                )}> {
                                  (this.state.masterComponent!=null && this.state.masterComponent.id!=null)?label.Update:label.Add
                                } </Button>

                              </ButtonGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={9}>
                      <Card body>
                        <Row>
                          <Col md={6}>
                            <ButtonGroup className="d-flex w-100">
                              <DropdownInput
                                  title={label.SortBy}
                                  options={orderOptions}
                                  onSelect={(item) => {
                                    this.refresh(ascending, item.field, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(ascending, "created", true)
                                  }}/>
                              &nbsp;&nbsp;&nbsp;
                              <DropdownInput
                                  options={ascendingOptions}
                                  onSelect={(item) => {
                                    this.refresh(item.field, sortir, true)
                                  }}
                                  onReset={() => {
                                    this.refresh(true, sortir, true)
                                  }}/>
                            </ButtonGroup>
                          </Col>
                          <Col md={6}>
                              <SearchInput
                                placeholder={label.Search}
                                value={search}
                                onChange={(e) => {
                                  let value = e.target.value
                                  this.setState({search:value}, () => {
                                    if(value==''){
                                      navigatePage(this.props, page=1)
                                    }
                                  })
                                }}
                                onEnter={(e) => {
                                  let value = e.target.value
                                  page = 1
                                  this.setState({search:value, page}, () => {
                                    navigatePage(this.props, page)
                                  })
                                }}/>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Table responsive hover>
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>{label.Name}</th>
                                <th>{label.Description}</th>
                                <th>{label.Length}</th>
                                <th>{label.Status}</th>
                                <th>{label.Updated}</th>
                                <th>{label.Edit}</th>
                              </tr>
                              </thead>
                              <tbody>
                              {
                                masterComponents.map((item, index) =>(
                                    <tr key={index}>
                                      <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                      <td>{item.label}</td>
                                      <td className="text-wrap">{item.description}</td>
                                      <td>{item.length}</td>
                                      <td><ActiveLabel active={item.active}/></td>
                                      <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                      <td>
                                        <Button color="primary" onClick={e=>(
                                            this.setState({
                                              masterComponent:item
                                            })
                                        )}>
                                          <MdEdit/>
                                        </Button>
                                      </td>
                                    </tr>
                                ))
                              }
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
                <Pagination {...this.props} currentPage={parseInt(page)} pageCount={totalPage} />
              </Card>
            </Col>
          </Row>
        </Page>
    );
  }
}

export default Object.assign(MasterComponentPage, {ENDPOINT : "/components"})
